import React, { useState } from 'react'
import I18n from '../../resources/i18n/I18n'
import WrapperLoader from '../loader/WrapperLoader'
import CustomBarChart from './CustomBarChart'
import SimplePieChart from './SimplePieChart'

const SwitchChart = ({ data, canSwitch, title, subtitle, loading, getData }) => {
  const [selectedChart, setSelectedChart] = useState('0') // Default: Pie Chart
  const [selectedAggregation, setSelectedAggregation] = useState('idType') // Default aggregation

  const handleChartSelection = (event) => {
    setSelectedChart(event.target.value)
  }

  const fetchData = (aggregation) => {
    setSelectedAggregation(aggregation)
    getData(aggregation)
  }

  return (
    <WrapperLoader loading={loading}>
      <div className="dashboard-tile">
        <div className="d-flex justify-content-between">
          <div className="legend">
            <div className="bold">{title}</div>
            <div>{subtitle}</div>
          </div>
          {canSwitch && (
            <div>
              <select className="browser-default custom-select" onChange={handleChartSelection} value={selectedChart}>
                <option value="0">{I18n.t('DashboardPieChart')}</option>
                <option value="1">{I18n.t('DashboardBarChart')}</option>
              </select>
            </div>
          )}
        </div>

        {selectedChart === '0' && <SimplePieChart data={data} />}
        {selectedChart === '1' && <CustomBarChart data={data} />}

        <div className="d-flex justify-content-around switch-chart">
          <div className={selectedAggregation === 'idType' ? 'active' : ''} onClick={() => fetchData('idType')}>
            Type
          </div>
          <div className={selectedAggregation === 'idSubtype' ? 'active' : ''} onClick={() => fetchData('idSubtype')}>
            Sous-type
          </div>
          <div className={selectedAggregation === 'idCategory' ? 'active' : ''} onClick={() => fetchData('idCategory')}>
            Catégorie
          </div>
        </div>
      </div>
    </WrapperLoader>
  )
}

export default SwitchChart
